module.exports = __webpack_public_path__ + "img/1525226928.b1661951.jpg";